import OBase from './OBase';

import * as Geometry from '../geometry';

export default class GateNand extends OBase {
  update () {
    var aValTree = this.getBoolInput('A');
    var bValTree = this.getBoolInput('B');

    var rOutput = this.getGenericObjectOutput('Result');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree, bValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var aVal = outDataTrees[0].branches[i][j];
        var bVal = outDataTrees[1].branches[i][j];

        let val = true;
        if (aVal) {
          if (bVal) {
            val = false;
          }
        }

        outTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    rOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/GateNand.js